import React from "react";

import svg from "../../assets/images/icons/Form Controls/value_slider.svg";

export const ValueSliderIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Slider"}
    />
);
